



























import { Component, Vue, Provide } from 'vue-property-decorator'
import { getChannelData, ChannelData } from './channel-service'
import { getPosition } from '@utils/index'
import { Sticky } from 'vant'
import { City, defaultCity } from '@app/core/constant/city'
import { getSelectedCity, allowRefreshOrShare } from '@utils/index'
import HomeOperate from '../components/common/home_operate.vue'
import BannerSection from '../components/banner/index.vue'
import SearchTab from '../components/search/search_tab.vue'
import OrderBtn from '../components/order/index.vue'
import Recovery from './components/recovery.vue'

@Component({
  components: {
    HomeOperate,
    SearchTab,
    BannerSection,
    OrderBtn,
    Recovery,
    [Sticky.name]: Sticky,
  },
})
export default class Channel extends Vue {
  cityInfo: City = defaultCity
  channelId = ''
  location: any = null
  channelData: ChannelData | null = null
  errormsg = '' //不为空 就实现错误页面
  sitckyTop = 0 //用来给tab组件吸顶的offsettop
  titleBarHeight = 0 //titleBar的高度  用来给recovery组件吸顶的offsettop
  query = '' //产康选择itemtype的值
  tabKey = 0 //重新加载searchTab

  @Provide()
  pageTrackParams: any = {
    bizType: '127',
    pageLevelId: '121012978',
    pageParam: { citycode: this.cityInfo.cityId, pindaoid: this.channelId, pindaoname: this.channelData?.channelName || '' },
  }
  @Provide()
  clickid_tab = '200005'
  @Provide()
  clickid_city = '200002'
  @Provide()
  clickid_search = '200001'
  @Provide()
  clickid_tab_business = '200010'
  @Provide()
  clickid_tab_product = '200011'

  //搜索结果页商家点击clickid
  @Provide()
  clickid_200003 = '200008'
  @Provide()
  clickid_200002 = '200007'
  @Provide()
  clickid_200001 = '200006'

  async created() {
    const { channelId } = this.$route.params
    //app搜索月嫂跳转月嫂频道页支持判断城市跳转甄选月嫂或联营月嫂页 https://www.tapd.cn/20019771/prong/stories/view/1120019771001088510
    //channelId=8 代表月嫂品类 
    if(channelId == '8'){
      location.replace(`//life.cekid.com/y/home?cmd=share&refresh=no&sharetype=0`)
    }else{
      location.replace(`//life.cekid.com/v2/channel?channelId=${channelId}`)
    }
    return;
    allowRefreshOrShare(false)
 
    this.channelId = channelId
    this.getChannelData()
    try {
      this.location = await getPosition(false)
      this.tabKey++ //重新请求搜索
    } catch (error) {
      console.log('定位失败')
    }
  }

  mounted() {
    const titleBar = this.$refs.titlebar as Vue
    const rect = titleBar.$el.getBoundingClientRect()
    this.titleBarHeight = rect.height
    this.sitckyTop = rect.height
  }

  //获取频道数据
  async getChannelData() {
    this.errormsg = ''
    try {
      this.channelData = await getChannelData(this.channelId, this.cityInfo.cityId)
      if (this.channelData.channelName) {
        this.$setTitle(this.channelData.channelName)
      }
      this.$tracker('127', '121012978')({ citycode: this.cityInfo.cityId, pindaoid: this.channelId, pindaoname: this.channelData.channelName || '' })
    } catch (error) {
      this.errormsg = error
    }
  }

  get showBanner() {
    const carousel = this.channelData?.ads?.carousel
    if (carousel && carousel.length > 0) {
      return true
    }
    return false
  }
  get showOperate() {
    const operate = this.channelData?.ads?.operate
    if (operate && operate.length >= 4) {
      return true
    }
    return false
  }

  getRecoveryHeight(val: any) {
    this.sitckyTop = this.titleBarHeight + val - 1
  }

  changeRecoveryTag(value: any) {
    if (value.isAll) {
      this.query = ''
    } else {
      const data = { [value.isType1 ? 'itemType1' : 'itemType2']: value.itemType }
      this.query = JSON.stringify(data)
    }
  }

  //是否是产后恢复
  get isRecovery() {
    return this.channelData && this.channelData.item && this.channelData.item.length > 0
  }

  operateClick(item: any) {
    this.$newClickTracker({ bizType: '127', pageLevelId: '121012978', clickId: '200003', pageParam: { citycode: this.cityInfo.cityId, pindaoid: this.channelId, pindaoname: this.channelData?.channelName || '' }, positionParam: { citycode: this.cityInfo.cityId, link: item.linkUrl, name: item.adsenseName } })
  }
  bannerClick(banner: any) {
    this.$newClickTracker({ bizType: '127', pageLevelId: '121012978', clickId: '200004', pageParam: { citycode: this.cityInfo.cityId, pindaoid: this.channelId, pindaoname: this.channelData?.channelName || '' }, positionParam: { link: banner.linkUrl, name: banner.adsenseName } })
  }
}
